import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormSimpleSelectField from 'components/ui/form/FormSimpleSelectField';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useFormSubmit from 'hooks/useFormSubmit';
import { memo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import FormDateField from 'components/ui/form/FormDateField';
import * as yup from 'yup';

const types = [
  {
    name: 'Obyekt',
    id: 1,
  },
  {
    name: 'Blok',
    id: 2,
  },
  {
    name: 'Hamkor',
    id: 3,
  },
];

const validationSchema = yup.object({
  isvalute: yup.number().required('Valyuta tanlash majburiy!'),
  category_id: yup.number().required('Kategoriya tanlash majburiy!'),
  account_id: yup.number().required('Kassani tanlash majburiy!'),
  date: yup.date().required('Sana'),
});

const ExpenseAddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemId, setItemId } = props;
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      date: '',
      isvalute: '',
      sum: '',
      reason_id: '',
      object_id: '',
      comment: '',
      type: '',
      category_id: '',
      account_id: '',
      partner_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemId) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/expense',
          values.name,
          itemId,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          '/admin/expense',
          values.name,
          null,
          false,
          handleFinishRequest
        );
    },
  });

  const { isLoading, isFetching } = useQuery({
    queryKey: '/admin/expense/edit/{itemId}',
    queryFn: async function () {
      const response = await axiosPrivate.get(`/admin/expense/edit/${itemId}`);
      return response.data.data;
    },
    onSuccess: (data) => {
      formik.setValues({
        isvalute: data?.isvalute ?? '',
        sum: data?.sum || '',
        reason_id: data?.reason_id || '',
        object_id: data?.object_id || '',
        comment: data?.comment || '',
        type: data?.type || '',
        category_id: data?.category_id || '',
        account_id: data?.account_id || '',
        date: data?.date || '',
        partner_id: data?.partner_id || '',
      });
    },
    enabled: !hasError && !!itemId,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemId('');
    setOpen(false);
    formik.resetForm();
  };
  useEffect(() => {
    formik.setFieldValue('reason_id', null);
    formik.setFieldValue('partner_id', null);
    formik.setFieldValue('object_id', null);
  }, [formik.values.type]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        {itemId ? (
          <span>Xarajatni tahrirlash</span>
        ) : (
          <span>Xarajat qo'shish</span>
        )}
      </DialogTitle>

      <DialogContent>
        {isLoading || isFetching ? (
          <div className='circular-progress-box py-5'>
            <CircularProgress size={35} />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              spacing={{ xs: 2, sm: 3, lg: 3 }}
              rowSpacing={1}
              columns={{ xs: 12, sm: 12, lg: 12 }}
            >
              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormDateField
                  delay={0}
                  label={'Sanasi'}
                  fieldName='date'
                  formik={formik}
                />
              </Grid>

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormSelectField
                  delay={0}
                  label={'Kategoriyasi'}
                  fieldName='category_id'
                  formik={formik}
                  path={'/dictionary/expense-category'}
                />
              </Grid>
              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormSelectField
                  delay={0}
                  label={'Kassa'}
                  fieldName='account_id'
                  formik={formik}
                  path={'/dictionary/selfaccounts'}
                />
              </Grid>

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormSelectField
                  delay={0}
                  label={'Valyuta'}
                  fieldName='isvalute'
                  formik={formik}
                  path={'/dictionary/valutes'}
                />
              </Grid>

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormCurrencyField
                  delay={0}
                  label={'Summa'}
                  fieldName='sum'
                  formik={formik}
                />
              </Grid>

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormSimpleSelectField
                  delay={0}
                  label={'Turi'}
                  fieldName='type'
                  options={types}
                  formik={formik}
                />
              </Grid>

              {formik?.values?.type == 3 && (
                <Grid item={true} lg={12} sm={12} xs={12}>
                  <FormSelectField
                    delay={0}
                    key={'partner_id'}
                    label={'Hamkor'}
                    fieldName={'partner_id'}
                    formik={formik}
                    disabled={!formik?.values?.type}
                    path={'/dictionary/partners'}
                  />
                </Grid>
              )}
              {formik?.values?.type != 3 && (
                <Grid
                  item={true}
                  lg={formik?.values?.type == 2 ? 6 : 12}
                  sm={formik?.values?.type == 2 ? 6 : 12}
                  xs={12}
                >
                  <FormSelectField
                    delay={0}
                    key={'object_id'}
                    label={'Obyekt'}
                    fieldName={
                      formik?.values?.type == 2 ? 'object_id' : 'reason_id'
                    }
                    formik={formik}
                    disabled={!formik?.values?.type}
                    path={'/dictionary/objects'}
                  />
                </Grid>
              )}
              {formik?.values?.type == 2 && (
                <Grid item={true} lg={6} sm={6} xs={12}>
                  <FormSelectField
                    key={'block_id'}
                    delay={0}
                    label={'Blok'}
                    fieldName='reason_id'
                    disabled={!formik?.values?.object_id}
                    formik={formik}
                    path={`/dictionary/blocks/${formik?.values?.object_id}`}
                    pathChangeable
                  />
                </Grid>
              )}

              <Grid item={true} lg={12} sm={12} xs={12}>
                <FormTextField
                  delay={0.1}
                  label={'Izoh'}
                  fieldName='comment'
                  multiline
                  rows={3}
                  formik={formik}
                />
              </Grid>

              <Grid item={true} sm={12} xs={12}>
                <FormActionButtons
                  delay={0.6}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default memo(ExpenseAddEditModal);
